import { render, staticRenderFns } from "./teachingBatchImport.vue?vue&type=template&id=9db5cdcc&scoped=true"
import script from "./teachingBatchImport.vue?vue&type=script&lang=js"
export * from "./teachingBatchImport.vue?vue&type=script&lang=js"
import style0 from "./teachingBatchImport.vue?vue&type=style&index=0&id=9db5cdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db5cdcc",
  null
  
)

export default component.exports